// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_b4-4";
export var collapsed = "_b4-1";
export var headerBar = "_b4-0";
export var leftHeaderContent = "_b4-3";
export var subjectContainer = "_b4-2";